
  import { Vue } from "vue-class-component";
  
  export default class ClockV2 extends Vue {}
  